import { render, staticRenderFns } from "./DownloadMenuItems.vue?vue&type=template&id=14c21af2&"
import script from "./DownloadMenuItems.vue?vue&type=script&lang=js&"
export * from "./DownloadMenuItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports